import { defineComponent as _defineComponent } from 'vue'
import {
  ref,
  watch,
  onMounted,
  withDefaults,
  nextTick
} from "../../../../adapter-vue";
import { TUIGlobal, IMessageModel } from "@tencentcloud/chat-uikit-engine";
import { handleSkeletonSize } from '../../utils/utils';
import type { IImageMessageContent } from "../../../../interface";


export default /*#__PURE__*/_defineComponent({
  __name: 'message-image',
  props: {
    content: { default: () => ({}) },
    messageItem: { default: () => ({} as IMessageModel) }
  },
  emits: ["uploading", "previewImage"],
  setup(__props: any, { emit: emits }) {

const props = __props as { content: IImageMessageContent, messageItem: IMessageModel }




const isPC = TUIGlobal.getPlatform() === 'pc';
const skeletonDomRef = ref();

onMounted(() => {
  if (props.messageItem?.status === "success") {
    autoFixSkeletonSize();
  }
});

watch(() => props.messageItem?.status, (newVal: string, oldVal: string) => {
  if (newVal === "success" && newVal !== oldVal) {
    emits("uploading");
  }
});

watch(() => props.content.height, (newVal: number, oldVal: number) => {
  if (newVal > oldVal) {
    autoFixSkeletonSize();
  }
})

function autoFixSkeletonSize() {
  const { width = 0, height = 0 } = props.content;
    if (width === 0 || height === 0) return;
    const containerWidth = document.getElementById("app")?.clientWidth || 0;
    const max = !isPC ? Math.min(containerWidth - 180, 300) : 300;
    const size = handleSkeletonSize(width, height, max, max);
    skeletonDomRef?.value?.style &&
      (skeletonDomRef.value.style.width = `${size.width}px`);
    skeletonDomRef?.value?.style &&
      (skeletonDomRef.value.style.height = `${size.height}px`);
    nextTick(() => {
      emits('uploading');
    })
}

function toggleShow() {
  if (props.messageItem?.status === 'success' || props.messageItem?.progress === 1) {
    emits("previewImage", props.messageItem);
  }
}

return { __sfc: true,emits, props, isPC, skeletonDomRef, autoFixSkeletonSize, toggleShow }
}

})